import EcoVideo from 'eco-design/base/eco-video';
import { useEffect, useRef } from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import css from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';

const F: React.FC = () => {
    const { t } = useLang('ats.F');
    /** 动画 */
    const infoRef = useRef<HTMLDivElement>(null);
    const { isPad, isH5 } = useDeviceDetect();
    useEffect(() => {
        const label = infoRef.current?.querySelector('.label');
        const title = infoRef.current?.querySelector('.title');
        const desc = infoRef.current?.querySelector('.desc');
        const video = document.querySelector('.smart-gateway-F .eco-video');
        const ani1 = AniContainer.create({
            triggerElement: infoRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                label?.classList.add('enter');
                title?.classList.add('enter');
                desc?.classList.add('enter');
                video?.classList.add('enter');
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    label?.classList.remove('enter');
                    title?.classList.remove('enter');
                    desc?.classList.remove('enter');
                    video?.classList.remove('enter');
                }
            },
        });
        return () => {
            ani1.destroy?.();
        };
    }, []);

    return (
        <>
            <EcoSpace />
            <section
                className={`${css.section} smart-gateway-F GtmModuleData-section`}
                id="smart-gateway-F"
                data-section-id={'smart-gateway-F'}
                data-section-title={t('title')}
            >
                <div className="info" ref={infoRef}>
                    <div className="left">
                        <div className="label ani-1">{t('label')}</div>
                        <div className="title ani-2">{t('title')}</div>
                    </div>
                    <div className="desc right ani-2-5">
                        {t.rich('desc', {
                            white: (a: string) => {
                                return <span className="white">{a}</span>;
                            },
                        })}
                    </div>
                </div>

                <div className="eco-video-box">
                    <EcoVideo
                        className="ani-3"
                        pc={'https://websiteoss.ecoflow.com/upload/video/1761290398989/03_Priority_ATS_1.mp4'}
                        autoPlay
                        loop
                        poster={
                            isPad || isH5
                                ? 'https://websiteoss.ecoflow.com/upload/image/1760171004882/m_When%20the%20Storm%20Hits_%20Lights%20Stay%20On%20(1).jpg'
                                : 'https://websiteoss.ecoflow.com/upload/image/1760170628917/pc_When%20the%20Storm%20Hits_%20Lights%20Stay%20On.jpg'
                        }
                        aria-label={t('F_title')}
                    />
                </div>
            </section>
        </>
    );
};

export default F;
